import { Component, OnInit, Inject, AfterViewInit, HostListener, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { catchError, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { environment } from '@env/environment';
import { svgIconList } from '@shared/svg-icon-list';
import { RequestReceipt } from '@shared/models/request-receipt.model';
import { RequestReceiptHttpService } from '@core/services/request-receipt-http.service';
import { UploadHttpService } from '@core/services/upload-http.service';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { MatStepperModule } from '@angular/material/stepper';
import { MatBadgeModule } from '@angular/material/badge';
import { SwalAlertComponent } from '@shared/swal-alert/swal-alert.component';

@Component({
  selector: 'app-request-receipt',
  imports: [CommonModule, TranslateModule, SafeHtmlPipe, MatStepperModule, MatBadgeModule, SwalAlertComponent],
  templateUrl: './request-receipt.component.html',
  styleUrls: ['./request-receipt.component.scss']
})
export class RequestReceiptComponent implements OnInit, AfterViewInit {
  @ViewChild('myFileInput') myFileInput: any;
  @ViewChild('stepper') stepper: any;

  newRequestIncoming: any;
  messages$: any;

  minimizeDialog = true;
  showBallon = true;
  depositData: RequestReceipt = null;

  uploadInProgress: boolean = false;
  fileName: string = null;

  form: FormGroup;
  formSubmitting: boolean = false;

  svg: any = svgIconList;
  max_receipts = 10;
  uploaded_receipts: any[] = [];
  uploaded_receipts_form: any[] = [];
  projectCode = environment.projectCode;

  constructor(
    private translateService: TranslateService,
    private requestReceiptHttpService: RequestReceiptHttpService,
    private dropdownHttpService: DropdownHttpService,
    private uploadHttpService: UploadHttpService,
    private sanitizer: DomSanitizer,
  ) { }

  @HostListener('window:resize', ['$event'])
  setRequestDialog(event?: any) {
    var requestDialog = document.getElementById('request-dialog');
    if (requestDialog) {
      var ballon = document.getElementsByClassName('receipt-floating-content')[0].getBoundingClientRect();
      var ballonWrapper = document.getElementById('receipt-floating-bubble');
  
      if (this.minimizeDialog) {
        requestDialog.style.top = ballon.top - (requestDialog.offsetHeight / 2) + 'px'
        requestDialog.style.left = ballon.left - (requestDialog.offsetWidth / 2) + 'px';
      } else {
        requestDialog.style.top = (window.innerHeight - requestDialog.offsetHeight) / 2 + 'px';
        requestDialog.style.left = (window.innerWidth - requestDialog.offsetWidth) / 2 + 'px';
        ballonWrapper.style.left = '15px';
      }
    }
  }

  ngOnInit() {

    this.newRequestIncoming = this.requestReceiptHttpService.newRequestIncoming;
    this.messages$ = this.requestReceiptHttpService.messages$;

    this.formInit();
    this.newRequestIncoming.subscribe(() => {
      this.resetValue();
      this.depositData = RequestReceiptHttpService.requestReceipt;
      this.onTogglePopup(this.depositData ? true : false);
    })
  }

  ngAfterViewInit(): void {
    const uploadReceiptForm = document.getElementById("uploadReceiptForm");
    if(uploadReceiptForm){
      uploadReceiptForm.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        uploadReceiptForm.scrollLeft += evt.deltaY;
      });
    }
    setTimeout(() => {
      this.setRequestDialog();
    }, 500);
  }

  onTogglePopup(forceExpand: boolean = false) {
    this.minimizeDialog = forceExpand ? false : !this.minimizeDialog;
    if (this.depositData == null) this.minimizeDialog = true;
    setTimeout(() => {
      this.setRequestDialog();
    }, 500); // Give 0.5s for the ngIf to render the <div> with 'request-dialog' before using it
    this.showBallon = true;
  }

  onCloseBallon() {
    this.showBallon = false;
  }

  onCancelDeposit() {
    Swal.fire({
      customClass: {
        popup: 'customPopup2',
        denyButton: 'deny-button',
        confirmButton: 'confirm-button',
      },
      html: '<div class="alert-svg alert-svg-'+ this.projectCode +'">' + (this.projectCode == 'qp20-dark' ? this.svg.triangleAlertIcon :  this.svg.alertIcon) + '</div>' +
        '<div class="text-center m-t-20">' +
        this.translateService.instant('Are you sure you want to cancel this deposit?') +
        '</div>',
      showDenyButton: true,
      showCloseButton: true,
      showConfirmButton: true,
      reverseButtons: true,
      denyButtonText: this.translateService.instant('NO'),
      confirmButtonText: this.translateService.instant('YES'),
    }).then(result => {
      if (result.isConfirmed) {
        this.formSubmitting = true;
        const data = {
          status: 2 // 2 = Rejected Status
        };
        this.requestReceiptHttpService.update(this.depositData.deposit_id, data).pipe(
          tap(res => {
            this.formSubmitting = false;
            this.resetValue();

            setTimeout(() => {
              this.onTogglePopup();
              this.onCloseBallon();
            }, 500);
          }),
          catchError(err => {
            this.formSubmitting = false;
            throw err;
          })
        ).subscribe();
      }
    });
  }

  onUploadFileMulti(event:any) {
    this.uploadInProgress = true;
    const file: File = event.target.files[0];
    if (file == null)  {
      this.uploadInProgress = false;
      return;
    }
    const formData = new FormData();
    this.fileName = file.name;
    formData.append('files', file);
    formData.append('type', this.dropdownHttpService.uploadTypes[2]);
    this.uploadHttpService.upload(formData).pipe(
      tap((res: any) => {
        this.uploadInProgress = false;
        this.uploaded_receipts.push({
          path: res[0].indexOf('.pdf') >= 0 ? this.sanitizer.bypassSecurityTrustResourceUrl(res[0]) : res,
          isPdf: res[0].indexOf('.pdf') >= 0 ? true : false,
        });
        this.uploaded_receipts_form.push(res[0]);
        this.form.patchValue({
          receipt_path: this.uploaded_receipts_form
        });
        this.form.get('receipt_path').markAsDirty();
        this.form.markAllAsTouched();
      }),
      catchError((error) => {
        this.uploadInProgress = false;
        throw error;
      })
    ).subscribe();
    event.target.value = null;
  }

  onRemoveFileMulti(idx?: any) {
    if( idx !== undefined ) {
      this.uploaded_receipts.forEach((value,index)=>{
        if(index==idx) this.uploaded_receipts.splice(index,1);
      });
      this.uploaded_receipts_form.forEach((value,index)=>{
        if(index==idx) this.uploaded_receipts_form.splice(index,1);
      });
    } else {
      this.uploaded_receipts = [];
      this.uploaded_receipts_form = [];
    }
    this.form.patchValue({
      receipt_path: this.uploaded_receipts_form
    });
    this.form.get('receipt_path').markAsDirty();
    this.form.markAllAsTouched();
  }

  onSubmit() {
    if (this.form.valid) {
      const data = {
        ...this.form.value,
        status: 0 // 0 = Pending Status
      };
      this.requestReceiptHttpService.update(this.depositData.deposit_id, data).pipe(
        tap(res => {
          this.formSubmitting = false;
          this.resetValue();
          setTimeout(() => {
            this.onTogglePopup();
            this.onCloseBallon();
          }, 500);
        }),
        catchError(err => {
          this.formSubmitting = false;
          throw err;
        })
      ).subscribe();
    }
  }
  private resetValue() {
    if(this.stepper){
      this.stepper.reset();
    }
    this.uploaded_receipts = [];
    this.uploaded_receipts_form = [];
    this.form.patchValue({
      receipt_path: null
    });
  }

  private formInit() {
    this.form = new FormGroup({
      receipt_path: new FormControl(null, [Validators.required])
    });
  }
}
